<template>
  <main>
    <section class="full-height">
      <mdb-container class="full-height py-4 px-2">
        <mdb-row class="pb-2 full-height">
          <mdb-col
            md="6"
            class="d-flex flex-column justify-content-center align-items-center text-center"
          >
            <h1>{{ video.name }}</h1>
            <small class="mb-0 px-2 py-1 badge-custom">
              {{ video.stack }}
            </small>
            <p class="pt-2 text-center description">{{ video.description }}</p>
          </mdb-col>
          <mdb-col
            md="6"
            class="d-flex justify-content-center align-items-center"
          >
            <video
              v-if="video.src"
              width="270"
              height="480"
              controls
              class="video"
            >
              <source
                :src="require(`@/assets/${video.src}.mp4`)"
                type="video/mp4"
              />
            </video>
          </mdb-col>
        </mdb-row>
      </mdb-container>
    </section>
  </main>
</template>

<script>
import { mdbContainer, mdbRow, mdbCol, mdbIcon, mdbBtn } from 'mdbvue'
import Navigation from './Navigation'
import { db } from '../main'

export default {
  name: 'VideoPlayer',
  components: {
    Navigation,
    mdbContainer,
    mdbRow,
    mdbCol,
    mdbIcon,
    mdbBtn,
  },
  data() {
    return {
      id: this.$route.params.id,
      video: {},
    }
  },
  firestore() {
    return {
      video: db.collection('videos').doc(this.id),
    }
  },
}
</script>

<style scoped>
main {
  background-color: #202020;
  min-height: 100vh;
}
h1 {
  font-weight: bold;
}
.video {
  border-radius: 15px;
}
.full-height {
  min-height: calc(100vh - 64px);
}
.badge-custom {
  background: #2b2b2b;
  border-radius: 20px;
  font-size: 80%;
  max-width: fit-content;
}
.description {
  text-wrap: balance;
}
@media (max-width: 767px) {
  h1 {
    font-size: 28px;
  }
  .badge-custom {
    font-size: 60%;
  }
  p {
    font-size: 13px;
    padding: 0 10px;
  }
}
</style>
